<div>
  <h1>{{title}}</h1>
  
  <p class="main" [innerHTML]="message"></p>
  
  <div class="actions">
    <button mat-raised-button color="primary" (click)="close()">OK</button>
  </div>
</div>